import { fromJS, List } from 'immutable';
import { CHANGE_PARAMETER, QUOTE_SUCCESS } from 'pu-redux/actions/QuoteActions';
import DefaultParameters from '../data/DefaultParameters';

const parameters = (state = fromJS(DefaultParameters), action) => {
  switch (action.type) {
    case CHANGE_PARAMETER: {
      const { name, value } = action;
      return state.set(
        name,
        name === 'quantities' ? List(value) : value,
      );
    }
    case QUOTE_SUCCESS: {
      return state.withMutations((s) => {
        s.set('product_quote_number', action.quote.number);
      });
    }

    default:
      return state;
  }
};

export default parameters;
